import { VisitorLimitsType } from '@fund-base/types/visitors/visitor-limits.types';
import {
  DEFAULT_AI_LETTERS_DAILY_LIMIT,
  DEFAULT_ALLOWED_SEARCH_RESULTS,
  DEFAULT_SEARCH_DAILY_LIMIT,
  DEFAULT_TRIAL_EXPIRES_AFTER_DAYS,
  getNumberOfAILetters,
  getNumberOfSearches,
  getUsageStartDate,
  getVisitorDailyAILettersLimit,
  getVisitorDailySearchLimit,
  getVisitorMaxSearchResults,
  getVisitorTrialExpiresAfterDays,
} from '@fund-base/utils/helpers/visitors/visitors.helpers';

export interface VisitorsState {
  limits: VisitorLimitsType;
  startDate?: Date;
  loading: boolean;
}

export const initialVisitorsState: VisitorsState = {
  limits: {
    dailySearches: {
      limit: getVisitorDailySearchLimit(),
      used: getNumberOfSearches(),
    },
    dailyAiLetters: {
      limit: getVisitorDailyAILettersLimit(),
      used: getNumberOfAILetters(),
    },
    maxSearchResults: getVisitorMaxSearchResults(),
    expiresInDays: getVisitorTrialExpiresAfterDays(),
  },
  startDate: getUsageStartDate(),
  loading: false,
};
